(function() {
  if (window.FavenHubspot) {
    return;
  }

  var HUBSPOT_BASE_URL = 'https://forms-na2.hsforms.com/submissions/v3/integration/submit';
  var IP_LOOKUP_URL = 'https://api.ipify.org?format=json';
  var DEFAULT_TIMEOUT = 15000;
  var cachedIpPromise;

  function getCookie(name) {
    var cookieString = document.cookie || '';
    var cookies = cookieString.split('; ');
    for (var i = 0; i < cookies.length; i += 1) {
      var parts = cookies[i].split('=');
      if (parts[0] === name) {
        return decodeURIComponent(parts.slice(1).join('='));
      }
    }
    return '';
  }

  function safeTrim(value) {
    if (value === undefined || value === null) {
      return '';
    }
    return String(value).trim();
  }

  function fetchPublicIp() {
    if (!cachedIpPromise) {
      cachedIpPromise = fetch(IP_LOOKUP_URL, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      })
        .then(function(response) {
          if (!response.ok) {
            return null;
          }
          return response.json();
        })
        .then(function(payload) {
          return payload && payload.ip ? payload.ip : undefined;
        })
        .catch(function() {
          return undefined;
        });
    }
    return cachedIpPromise;
  }

  function buildContext(extraContext) {
    return Promise.all([fetchPublicIp()]).then(function(results) {
      var ipAddress = results[0];
      var context = {
        pageUri: window.location.href,
        pageName: document.title || 'Faven Lighting'
      };

      var hutk = safeTrim(getCookie('hubspotutk'));
      if (hutk) {
        context.hutk = hutk;
      }

      if (ipAddress) {
        context.ipAddress = ipAddress;
      }

      if (extraContext && typeof extraContext === 'object') {
        for (var key in extraContext) {
          if (Object.prototype.hasOwnProperty.call(extraContext, key)) {
            context[key] = extraContext[key];
          }
        }
      }

      return context;
    });
  }

  function sanitizeFields(fields) {
    return fields
      .filter(function(field) {
        return field && field.name;
      })
      .map(function(field) {
        return {
          objectTypeId: field.objectTypeId || '0-1',
          name: field.name,
          value: safeTrim(field.value)
        };
      })
      .filter(function(field) {
        return field.value !== '';
      });
  }

  function submitHubspotForm(config) {
    if (!config || !config.portalId || !config.formGuid) {
      return Promise.reject(new Error('Missing HubSpot portalId or formGuid.'));
    }

    if (!Array.isArray(config.fields)) {
      return Promise.reject(new Error('HubSpot submission requires a fields array.'));
    }

    var sanitizedFields = sanitizeFields(config.fields);
    if (!sanitizedFields.length) {
      return Promise.reject(new Error('At least one HubSpot field is required.'));
    }

    var timeoutMs = typeof config.timeoutMs === 'number' ? config.timeoutMs : DEFAULT_TIMEOUT;
    var controller = new AbortController();
    var timeoutHandle = setTimeout(function() {
      controller.abort();
    }, timeoutMs);

    return buildContext(config.extraContext)
      .then(function(context) {
        var payload = {
          fields: sanitizedFields,
          context: context
        };

        if (config.legalConsentOptions) {
          payload.legalConsentOptions = config.legalConsentOptions;
        }

        return fetch(HUBSPOT_BASE_URL + '/' + config.portalId + '/' + config.formGuid, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload),
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer',
          signal: controller.signal
        });
      })
      .then(function(response) {
        if (!response.ok) {
          return response.text().then(function(message) {
            throw new Error(message || 'HubSpot request failed with status ' + response.status);
          });
        }
        return response.json().catch(function() {
          return {};
        });
      })
      .finally(function() {
        clearTimeout(timeoutHandle);
      });
  }

  window.FavenHubspot = Object.freeze({
    submitHubspotForm: submitHubspotForm,
    getCookie: getCookie
  });
})();
